import React from 'react';
import { Wrapper, TimeAgoSkeleton, TimeRangeSkeleton } from './styles';
export var Skeleton = function Skeleton() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TimeRangeSkeleton, {
    width: 80
  }), /*#__PURE__*/React.createElement(TimeAgoSkeleton, {
    width: 150
  }));
};
export default Skeleton;